import { Route, Routes } from 'react-router-dom';
import EventDetail from './pages/EventDetail';
import Home from './pages/Home';

const AppRoutes = () => {
    return (
        <Routes>
            <Route path="/" element={<Home />} /> {/* Home or list of events */}
            <Route path="/events/:id" element={<EventDetail />} /> {/* Event detail page */}
        </Routes>
  );
};

export default AppRoutes;